export default __webpack_public_path__ + "assets/images/c2f94d96e462b92d9498acb827a5c318.png";